import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import './DisbursementsAndProjectsForTheYear.scss';
import { Bar, Line } from 'react-chartjs-2';
import { getProjectsSimpleTableIndicatorDisburmentProjection } from '../../../redux/actions/indicatorProjects';
import DisbursementsAndProjectsForTheYearTable from './Table/DisbursementsAndProjectsForTheYearTable';
import useTable from '../../../hooks/useTable';
import { ReactComponent as IconBack } from '../../../assets/icons/u_arrow-left.svg';
import { ReactComponent as IconForward } from '../../../assets/icons/u_arrow-right.svg';
import { DisbursementsAndProjectsForTheYearHeader } from './DisbursementsAndProjectsForTheYearHeader';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import Check from '@material-ui/icons/Check';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';
import { FormControlLabel, withStyles } from '@material-ui/core';
import { InfoTooltipWithTitleOnModal } from '../../Util/Tooltip/InfoTooltipWithTitleOnModal/InfoTooltipWithTitleOnModal';
import ErrorMessageView from '../../Util/ErrorMessage/ErrorMessageView';

type StateArrow = {
  arrowRight: boolean;
  arrowLeft: boolean;
};

const labelsMonthArray = [
  'january_short',
  'february_short',
  'march_short',
  'april_short',
  'may_short',
  'june_short',
  'july_short',
  'august_short',
  'september_short',
  'october_short',
  'november_short',
  'december_short',
];

export const DisbursementsAndProjectsForTheYear = () => {
  const dispatch = useDispatch();
  const { currentIndicator } = useSelector<any, any>(state => state);
  const indicatorProjects = useSelector<any, any[]>(state => state.indicatorProjects);
  const [dataFilterMonth, setDataFilterMonth] = useState<any>([]);
  const [filteredProjectsByOperations, setFilteredProjectsByOperations] = useState<any[]>([]);
  const [labelsMonth, setLabelsMonth] = useState<any>();
  const [valueFilterTextDefault, setValueFilterTextDefault] = useState<string>();
  const [disabledFilter, setDisabledFilter] = useState<boolean>(false);
  const [disabledArrow, setDisabledArrow] = useState<StateArrow>({ arrowRight: false, arrowLeft: true });
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const { projects } = useTable();
  const date = new Date();
  const [year, setYear] = useState<number>(date.getFullYear());
  const [month, setMonth] = useState<number>(date.getMonth() + 1);
  const [hoverMonth, setHoverMonth] = useState<number | null>(date.getMonth());
  const { t } = useTranslation();
  const [checkedOperations, setCheckedOperations] = useState(true);
  const [checkedOperationsDisable, setCheckedOperationsDisable] = useState(false)
  const [checkedSubOperations, setCheckedSubOperations] = useState(true);
  const [checkedSubOperationsDisable, setCheckedSubOperationsDisable] = useState(true);

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const stateProjectProductTypes = useSelector<any, FilterIndicators>(
    state => state.indicatorPayload.payload.projectProductTypes,
  );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = useState(false);
  const [headerError, setHeaderError] = useState(false)
  const [totalProjectsData, setTotalProjectsData] = useState(false);
  const [flag, setFlag] = useState<boolean>(false);

  const projectTypeFilterChange = {
    ...filterIndicators,
    common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
    projectTypeFilters: stateProjectProductTypes,
  };

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);
    setHeaderError(false)

    try {
      const indicatorsToProcess = await getNewFilteredIndicators(
        {},
        { projectProductTypes: stateProjectProductTypes },
        {
          ...projectTypeFilterChange.common,
          operations: getOperationsFilter()
        },
      );
      const disbIndicator = indicatorsToProcess?.indicatorsData?.find(
        i => i.key === 'DISBURSEMENTS_AND_PROJECTIONS_FOR_THE_YEAR',
      );
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjectsData(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      setHeaderError(true)
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const handleRetry = () => {
    handleCommonFilterChange();
    getFilteredSimpleIndicatorsDisburmentProjection(
      dispatch,
      currentIndicator.id,
      currentIndicator.indicatorKey,
      setLoadingData,
      setHeaderError,
      { ...filterIndicators, common: { ...filterIndicators.common } },
    );
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(
      setCurrentIndicator(
        sendEndSummary?.find(data => data.indicatorKey === 'DISBURSEMENTS_AND_PROJECTIONS_FOR_THE_YEAR'),
      ),
    );
    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  //Graphits

  const fontsColor = '#101319';
  const graphFontFamily = 'Rubik';
  const chartStepSize = 500000000;

  const [dataBarGraph, setDataBarGraph] = useState<any>({
    original: 0,
    current: 0,
    disburment: 0,
  });

  const [dataLineGraph, setDataLineGraph] = useState<any>({
    original: 0,
    current: 0,
    disburment: 0,
  });

  //variables para grafica Bar
  const storageOriginalProjectsMonth: number[] = [];
  const storageCurrentProjectsMonth: number[] = [];
  const storageDisburmentMonth: number[] = [];

  //variables para grafica Line

  const storageLineOriginalProjectsMonth: number[] = [];
  const storageLineCurrentProjectsMonth: number[] = [];
  const storageLineDisburmentMonth: number[] = [];

  let dataOriginalProjectionFile;
  let dataCurrentProjectionFile;
  let dataDisburmentFile;

  useEffect(() => {
    getFilteredSimpleIndicatorsDisburmentProjection(
      dispatch,
      currentIndicator.id,
      currentIndicator.indicatorKey,
      setLoadingData,
      setHeaderError,
      { ...filterIndicators, common: { ...filterIndicators.common } },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndicator.id, dispatch, filterIndicators.common, checkedOperations, checkedSubOperations]);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    // re-fetch indicator summary (header) when toggling operations filters
    handleCommonFilterChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedOperations, checkedSubOperations]);

  useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0 &&
      flag
    ) {
      handleCommonFilterChange();
      setFlag(false);
      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    const filtered = indicatorProjects.filter(item => {
      const op = Number(item.field11);
      if (checkedOperations && checkedSubOperations) return true;
      if (checkedOperations) return op === 0;
      if (checkedSubOperations) return op === 1;
      return true;
    });
    setFilteredProjectsByOperations(filtered);
  }, [indicatorProjects, checkedOperations, checkedSubOperations]);

  useEffect(() => {
    if (filteredProjectsByOperations) {
      dataBarProjectionMonthRecursiva(filteredProjectsByOperations, 1, year);
      dataLineProjectionMonthRecursiva(filteredProjectsByOperations, 1, year);
      filterDataYearAndMonths(month, year, filteredProjectsByOperations);
      setHoverMonth(month - 1);
    }
  }, [filteredProjectsByOperations]);

  const dataBarProjectionMonthRecursiva = (data, numero, year, arrow?) => {
    if (numero === 13) {
      setDataBarGraph({
        original: storageOriginalProjectsMonth,
        current: storageCurrentProjectsMonth,
        disburment: storageDisburmentMonth,
      });

      if (arrow === 'next') {
        const dataLabels = labelsMonthArray.slice(0, 4).map(item => t(item));
        setLabelsMonth(dataLabels);
      } else {
        const dataLabels = labelsMonthArray.map(item => t(item));
        setLabelsMonth(dataLabels);
      }

      return;
    }

    const dataOriginalProjection = data
      .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
      .reduce((acc, value) => acc + Number(value.field1), 0);

    const dataCurrentProjection = data
      .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
      .reduce((acc, value) => acc + Number(value.field2), 0);

    const dataDisburment = data
      .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
      .reduce((acc, value) => acc + Number(value.field3), 0);

    storageOriginalProjectsMonth.push(dataOriginalProjection);
    storageCurrentProjectsMonth.push(dataCurrentProjection);
    storageDisburmentMonth.push(dataDisburment);

    dataBarProjectionMonthRecursiva(data, numero + 1, year, arrow);
  };

  const dataLineProjectionMonthRecursiva = (data, numero, year) => {
    if (numero === 13) {
      setDataLineGraph({
        original: storageLineOriginalProjectsMonth,
        current: storageLineCurrentProjectsMonth,
        disburment: storageLineDisburmentMonth,
      });
      return;
    }

    if (numero === 1) {
      dataOriginalProjectionFile = data
        .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
        .reduce((acc, value) => acc + Number(value.field1), 0);
    } else {
      dataOriginalProjectionFile =
        data
          .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
          .reduce((acc, value) => acc + Number(value.field1), 0) + dataOriginalProjectionFile;
    }

    if (numero === 1) {
      dataCurrentProjectionFile = data
        .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
        .reduce((acc, value) => acc + Number(value.field2), 0);
    } else {
      dataCurrentProjectionFile =
        data
          .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
          .reduce((acc, value) => acc + Number(value.field2), 0) + dataCurrentProjectionFile;
    }

    if (numero === 1) {
      dataDisburmentFile = data
        .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
        .reduce((acc, value) => acc + Number(value.field3), 0);
    } else {
      dataDisburmentFile =
        data
          .filter(item => Number(item.field5) === numero && Number(item.field6) === year)
          .reduce((acc, value) => acc + Number(value.field3), 0) + dataDisburmentFile;
    }

    storageLineOriginalProjectsMonth.push(dataOriginalProjectionFile);
    storageLineCurrentProjectsMonth.push(dataCurrentProjectionFile);
    storageLineDisburmentMonth.push(dataDisburmentFile);

    dataLineProjectionMonthRecursiva(data, numero + 1, year);
  };

  const filterDataYearAndMonths = (month, year, projectsSource = filteredProjectsByOperations) => {
    if (month >= 1 && month <= 12) {
      setValueFilterTextDefault(month);
      setDataFilterMonth(
        projectsSource.filter(item => Number(item.field5) === month && Number(item.field6) === year),
      );
    } else if (month === 0) {
      setValueFilterTextDefault(month);
      setDataFilterMonth(projectsSource.filter(item => Number(item.field6) === year));
    } else if (month === 13) {
      setValueFilterTextDefault(month);
      setDataFilterMonth(
        projectsSource.filter(
          item => Number(item.field5) >= 1 && Number(item.field5) <= 3 && Number(item.field6) === year,
        ),
      );
    } else if (month === 14) {
      setValueFilterTextDefault(month);
      setDataFilterMonth(
        projectsSource.filter(
          item => Number(item.field5) >= 4 && Number(item.field5) <= 6 && Number(item.field6) === year,
        ),
      );
    } else if (month === 15) {
      setValueFilterTextDefault(month);
      setDataFilterMonth(
        projectsSource.filter(
          item => Number(item.field5) >= 7 && Number(item.field5) <= 9 && Number(item.field6) === year,
        ),
      );
    } else if (month === 16) {
      setValueFilterTextDefault(month);
      setDataFilterMonth(
        projectsSource.filter(
          item => Number(item.field5) >= 10 && Number(item.field5) <= 12 && Number(item.field6) === year,
        ),
      );
    }
  };

  const dataBar = {
    labels: labelsMonth,
    yearsList: [year],
    datasets: [
      {
        label: t('new_orginila_projection'),
        data: dataBarGraph.original,
        backgroundColor: [
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
          '#5a6a8a',
        ],
        barThickness: 10,
      },
      {
        label: t('new_current_projection'),
        data: dataBarGraph.current,
        backgroundColor: [
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
          '#a0abc1',
        ],
        barThickness: 10,
      },
      {
        label: t('DI'),
        data: dataBarGraph.disburment,
        backgroundColor: [
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
          '#236bff',
        ],
        barThickness: 10,
      },
    ],
  };

  const dataLine = {
    labels: labelsMonth,
    yearsList: [year],
    completeGroupingValue: [
      {
        month: '1',
        year: 2025,
        value: 20531510,
      },
      {
        month: '2',
        year: 2025,
        value: 72609700,
      },
      {
        month: '3',
        year: 2025,
        value: 240277000,
      },
      {
        month: '4',
        year: 2025,
        value: 26887130,
      },
      {
        month: '5',
        year: 2025,
        value: 37844000,
      },
      {
        month: '6',
        year: 2025,
        value: 28115790,
      },
      {
        month: '7',
        year: 2025,
        value: 47775070,
      },
    ],
    datasets: [
      {
        label: t('new_orginila_projection'),
        data: dataLineGraph.original,
        borderColor: '#5a6a8a',
        fill: false,
      },
      {
        label: t('new_current_projection'),
        data: dataLineGraph.current,
        borderColor: '#a0abc1',
        fill: false,
      },
      {
        label: t('DI'),
        data: dataLineGraph.disburment,
        borderColor: '#236bff',
        fill: false,
      },
    ],
  };

  const optionsBar = {
    annotation: {
      annotations: [
        {
          backgroundColor: '#F1F3FF',
          drawTime: 'beforeDatasetsDraw',
          cornerRadius: 0,
          type: 'box',
          xScaleID: 'x-axis-0',
          xMin: hoverMonth ? hoverMonth - 0.5 : 0,
          xMax: hoverMonth ? hoverMonth + 0.5 : 0,
        },
      ],
    },
    tooltips: {
      enabled: true,
      backgroundColor: '#101319',
      bodyFontColor: '#ffffff',
      bodyFontFamily: 'Rubik',
      titleFontColor: '#ffffff',
      titleFontSize: 14,
      bodyFontSize: 14,

      callbacks: {
        title: (tooltipItem, data) => {
          return tooltipItem[0].xLabel + ' ' + data.yearsList[0];
        },
        label: (tooltipItem, data) => {
          const currentYear = new Date().getFullYear();
          const value = `${t('dolar_sign')} ${tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
          return `${t(data['datasets'][tooltipItem.datasetIndex].label)} ${value}`;
        },
      },
    },
    plugins: {
      datalabels: { display: false },
    },
    legend: {
      display: false,
    },
    hover: {
      onHover: (event, chartElement) => {
        event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
      },
    },
    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true,
            fontSize: 12,
            fontStyle: 400,
            color: ' #101319',
            fontColor: '#101319',
            fontFamily: 'rubik',
            fontWeight: 400,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: false,
          ticks: {
            stepSize: chartStepSize,
            beginAtZero: true,
            fontSize: 12,
            fontFamily: graphFontFamily,
            fontColor: fontsColor,
            callback: (value, ctx) => {
              return `${Math.round(value / 1000000)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
            },
          },
          scaleLabel: {
            display: true,
            labelString: `${t('millions_word')} ${t('dolar_sign')}`,
            fontSize: 10,
            fontFamily: graphFontFamily,
            fontColor: fontsColor,
          },
          gridLines: {
            display: true,
          },
        },
      ],
    },
    cornerRadius: 4,
  };

  const optionsLine = {
    tooltips: {
      enabled: true,
      backgroundColor: '#101319',
      bodyFontColor: '#ffffff',
      bodyFontFamily: 'Rubik',
      titleFontColor: '#ffffff',
      titleFontSize: 14,
      bodyFontSize: 14,

      callbacks: {
        title: (tooltipItem, data) => {
          return tooltipItem[0].xLabel + ' ' + data.yearsList[0];
        },
        label: (tooltipItem, data) => {
          const currentYear = new Date().getFullYear();
          const value = `${t('dolar_sign')} ${tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
          if (tooltipItem.datasetIndex === 0) {
            const year = data.yearsList[tooltipItem.index];
            return year === currentYear
              ? `${t(data['datasets'][tooltipItem.datasetIndex].label)} ${value}`
              : `${t('original_projection')} ${value}`;
          }
          return `${t(data['datasets'][tooltipItem.datasetIndex].label)} ${value}`;
        },
      },
    },
    plugins: {
      datalabels: { display: false },
    },
    legend: {
      display: false,
    },
    hover: {
      onHover: (event, chartElement) => {
        event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
      },
    },
    chartArea: {
      backgroundColor: 'rgba(251, 85, 85, 0.4)',
    },
    elements: { line: { tension: 0 } },
    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true,
            fontSize: 12,
            fontStyle: 400,
            color: ' #101319',
            fontColor: '#101319',
            fontFamily: 'rubik',
            fontWeight: 400,
          },
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          stacked: false,
          ticks: {
            stepSize: chartStepSize,
            beginAtZero: true,
            fontSize: 12,
            fontFamily: graphFontFamily,
            fontColor: fontsColor,
            callback: (value, ctx) => {
              return `${Math.round(value / 1000000)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
            },
          },
          scaleLabel: {
            display: true,
            labelString: `${t('millions_word')} ${t('dolar_sign')}`,
            fontSize: 10,
            fontFamily: graphFontFamily,
            fontColor: fontsColor,
          },
          gridLines: {
            display: true,
          },
        },
      ],
    },
  };

  const onClickBar = e => {
    const changeMonth = e[0]?._index + 1;
    filterDataYearAndMonths(changeMonth, year);
  };

  const getOperationsFilter = () => {
    const operations: number[] = [];
    if (checkedOperations) {
      operations.push(0);
    }
    if (checkedSubOperations) {
      operations.push(1);
    }
    return operations;
  };

  const chageYear = text => {
    const date = new Date();
    if (text === 'next') {
      setYear(prev => prev + 1);
      dataBarProjectionMonthRecursiva(filteredProjectsByOperations, 1, year + 1, text);
      dataLineProjectionMonthRecursiva(filteredProjectsByOperations, 1, year + 1);
      filterDataYearAndMonths(1, year + 1, filteredProjectsByOperations);
      setDisabledFilter(true);
      setDisabledArrow({ arrowRight: true, arrowLeft: false });
      setHoverMonth(null);
    } else if (text === 'prev') {
      setYear(date.getFullYear());
      dataBarProjectionMonthRecursiva(filteredProjectsByOperations, 1, year - 1, text);
      dataLineProjectionMonthRecursiva(filteredProjectsByOperations, 1, year - 1);
      filterDataYearAndMonths(1, year - 1, filteredProjectsByOperations);
      setDisabledFilter(false);
      setDisabledArrow({ arrowRight: false, arrowLeft: true });
      setHoverMonth(month - 1);
    }
  };

  const dimensionsBar = { height: 200 };
  const dimensionsLine = { height: 200 };

  const handleCheckOperations = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedOperations(event.target.checked);
  };

  const handleCheckSubOperations = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedSubOperations(event.target.checked);
  };

  useEffect(() => {
    if (!checkedOperations) {
      setCheckedSubOperations(true)
      setCheckedOperationsDisable(true)
    } else {
      setCheckedOperationsDisable(false)
    }
  }, [checkedOperations])

  useEffect(() => {
    if (!checkedSubOperations) {
      setCheckedOperations(true)
      setCheckedSubOperationsDisable(true)
    } else {
      setCheckedSubOperationsDisable(false)
    }
  }, [checkedSubOperations])

  const CheckedIcon = () => (
    <div
      style={{
        width: 18,
        height: 18,
        boxSizing: 'border-box',
        backgroundColor: '#236BFF  ',
        borderRadius: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Check style={{ color: '#ffffff', fontSize: 16 }} />
    </div>
  );

  const CheckedIconDisabled = () => (
    <div
      style={{
        width: 18,
        height: 18,
        backgroundColor: '#5F6B8A',
        borderRadius: 3,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Check style={{ color: '#ffffff', fontSize: 16 }} />
    </div>
  );

  const UncheckedIcon = () => (
    <div
      style={{
        width: 18,
        height: 18,
        boxSizing: 'border-box',
        borderRadius: 3,
        border: '1px solid #5F6B8A',
        background: 'transparent',
      }}
    />
  );

  const UncheckedIconDisabled = () => (
    <div
      style={{
        width: 18,
        height: 18,
        boxSizing: 'border-box',
        borderRadius: 3,
        border: '1px solid #5F6B8A',
        background: 'transparent',
      }}
    />
  );

  const ModifiedCheckbox = withStyles({
    root: {
      width: 18,
      padding: 18,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      transform: 'none',
      '&$disabled': {
        opacity: 1,
      },
    },
    disabled: {},
  })((props: CheckboxProps) => (
    <Checkbox
      color="default"
      icon={props.disabled ? <UncheckedIconDisabled /> : <UncheckedIcon />}
      checkedIcon={props.disabled ? <CheckedIconDisabled /> : <CheckedIcon />}
      {...props}
    />
  ));

  if (headerError) {
    return (
      <div className="disbursements-error-container">
        <ErrorMessageView
          title={t('title_error_message_view')}
          description={t('desc_error_message_tab')}
          reload={handleRetry}
          isIndicator={true}
        />
      </div>
    );
  }

  return (
    <>
      <div className="general-container">
        <div className="checkbox-content">
          <div className='checkbox-operations'>
            <ModifiedCheckbox
              checked={checkedOperations}
              onChange={handleCheckOperations}
              inputProps={{ 'aria-label': 'primary checkbox' }}
              disabled={checkedSubOperationsDisable}
            />
            <p>{t('operations')}</p>
          </div>
          <div className='checkbox-operations'>
            <ModifiedCheckbox
              checked={checkedSubOperations}
              onChange={handleCheckSubOperations}
              inputProps={{ 'aria-label': 'primary checkbox' }}
              disabled={checkedOperationsDisable}
            />
            <p>{t('suboperations')}</p>
          </div>
        </div>
        <DisbursementsAndProjectsForTheYearHeader />

        <section className="container-graphics">
          <div className="container-bar-buttons">
            <button className="buttons-bar" onClick={() => chageYear('prev')} disabled={disabledArrow.arrowLeft}>
              <span className="icon">
                <IconBack />
              </span>
            </button>
            <div className="container-bar">
              <p className="title-graphic">{t('new_monthly_data_graph')}</p>
              <Bar options={optionsBar} data={dataBar} getElementsAtEvent={onClickBar} {...dimensionsBar} />
            </div>
            <button className="buttons-bar" onClick={() => chageYear('next')} disabled={disabledArrow.arrowRight}>
              <span className="icon">
                <IconForward />
              </span>
            </button>
          </div>

          <div className="container-line">
            <p className="title-graphic">{t('new_cumulative_data_graph')}</p>
            <Line options={optionsLine} data={dataLine} {...dimensionsLine} />
          </div>
        </section>
        <section className="container-legent">
          <div className="container-legent-original">
            <p>
              <span></span> {t('new_orginila_projection')}
            </p>
          </div>
          <div className="container-legent-current">
            <p>
              <span></span> {t('current_disbursement_plus_current_projection')}
              <InfoTooltipWithTitleOnModal
                title={t('current_disbursement_plus_current_projection')}
                message={t('current_disbursement_plus_current_projection_description')}
                trigger='click' />
            </p>
          </div>
          <div className="container-legent-disbursed">
            <p>
              <span></span> {t('DI')}
            </p>
          </div>
        </section>
        <section>
          <DisbursementsAndProjectsForTheYearTable
            dataTable={dataFilterMonth}
            fnChangeData={filterDataYearAndMonths}
            labelFilterDefault={valueFilterTextDefault}
            disabledFilter={disabledFilter}
            loadingData={loadingData}
          />
        </section>
      </div>
    </>
  );
};
const getFilteredSimpleIndicatorsDisburmentProjection = (
  d,
  currentIndicatorId,
  currentIndicatorKey,
  setLoading,
  setError,
  customFilterIndicators?,
) => {
  setLoading(true);
  setError(false);
  return d(
    getProjectsSimpleTableIndicatorDisburmentProjection(
      currentIndicatorId,
      currentIndicatorKey,
      customFilterIndicators,
    ),
  )
    .then(() => {
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      setError(true);
    });
};
